/*======= прокрутка плаваящего меню =======*/
import SpecsNavigate from "./SpecsNavigate";
import SearchableSelect from "../../SearchableSelect";
import {hintsInit} from "../../helpers/Hints";

window.addEventListener('load', function(){
    (new SpecsNavigate).init();

    const generations_select_element = $('#generations_select');
    const generations_years_select_element = $('#years_generations_select');

    const renderSpecsGen = function(gen_id){
        $.get("/ajax/getGenSpecsContent", {gen_id: gen_id}, function(d){
            $('.model-specs-container').replaceWith(d);
            (new SpecsNavigate).init();
            hintsInit();
        })
    }

    const genSelect = new SearchableSelect(generations_select_element, {
        searchInput: false,
        classes: 'transparentType',
        onSelect: function(gen_id){
            renderSpecsGen(gen_id);
        }
    });

    const yearSelect = new SearchableSelect(generations_years_select_element, {
        searchInput: false,
        classes: 'transparentType',
        onSelect: function(year){

            const model_id = $('.models_tabs').data('model_id');

            $.get('/ajax/getGenerationsByYear', {year: year, model_id: model_id}, function(d){
                if(d.data.gens.length > 0){

                    let options = [];

                    d.data.gens.forEach(gen => {
                        options.push({
                            value: gen.id,
                            text: gen.name,
                        })
                    })

                    genSelect.setOptions(options);

                    if(options.length === 1){
                        renderSpecsGen(options[0].value);
                    }else{
                        genSelect.open();
                    }

                }
            })

        }
    });

    $('.slideDownCommentBtn').on('click', function(){
        $(this).closest('dl').next().slideToggle();
    })


})
/*=========================================*/